// extracted by mini-css-extract-plugin
export default {"chatHistory":"ChatHistory_chatHistory__KYFDW","emptyState":"ChatHistory_emptyState__TDrWY","messagesList":"ChatHistory_messagesList__i81l0"};